/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Loading from 'components/Loading/Loading';

import Form from 'forms/_.extend';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import SelfAuditMultiForm from './SelfAuditMultiForm/SelfAuditMultiForm';
import SelfAuditMultiSuccess from './SelfAuditMultiSuccess/SelfAuditMultiSuccess';
import SelfAuditMultiError from './SelfAuditMultiError/SelfAuditMultiError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  assetStore: Object,
};

@translate()
@inject('actionDrawerStore', 'assetStore')
@observer
export default class SelfAuditMulti extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;
    const ids = asset.map(a => a.id);

    const fields: Array<Object> = [
      {
        name: 'auditDetails',
        label: t('actionDrawer:Audit Details'),
        fields: [
          {
            name: 'assetIds',
            label: t('actionDrawer:assets'),
            rules: '',
            value: ids,
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { assetIds } = data.values().auditDetails;

        actionDrawerStore.selfAuditMultiByLocation({
          ids: assetIds,
        });
      },
    };
    return new Form(
      { fields },
      {
        hooks,
        name: 'selfAuditMulti',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;
    const title: string = t('actionDrawer:Confirm Audit');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <SelfAuditMultiError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <SelfAuditMultiSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={`${styles['action-drawer-form']} ${styles.success}`}>
        <ActionDrawerHeader title={title} />
        <SelfAuditMultiForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
